import { stacksViewSx } from '@components/_shared/sxStyles/Config/stacks';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { STACK_STRINGS } from '../constants';
import StackActionButton from './StackActionButton';

interface StackEmptyStateProps {
  isAdmin: boolean;
  onActionClick: () => void;
}

const StackEmptyState: React.FC<StackEmptyStateProps> = ({
  isAdmin,
  onActionClick,
}) => {
  if (isAdmin) {
    return (
      <Box sx={stacksViewSx.view.emptyState.container}>
        <Typography sx={stacksViewSx.view.titles.noModes}>
          {STACK_STRINGS.NO_DEFAULT_STACK}
        </Typography>
        <StackActionButton hasDefaultStack={false} onClick={onActionClick} />
      </Box>
    );
  }

  return (
    <Typography sx={stacksViewSx.view.titles.noModes}>
      {STACK_STRINGS.NO_DEFAULT_STACK}
    </Typography>
  );
};

StackEmptyState.displayName = 'StackEmptyState';

export default React.memo(StackEmptyState);
